import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {isEmpty} from 'lodash/lang';
import {SecondaryNavigation} from 'components/Navigation';
import SubscriptionList from 'components/Subscription/SubscriptionList';
import SubscriptionOverview from '../Subscription/SubscriptionOverview';
import {fetchClassroom} from 'actions/classrooms';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';

class ClassroomSubscriptionList extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };
  static propTypes = {
    classroom: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      overviewKey: 0,
    };
    this.fetchClassroom = this.fetchClassroom.bind(this);
  }

  componentDidMount() {
    this.fetchClassroom();
  }

  fetchClassroom() {
    const {
      fetchClassroom,
      formatErrors,
      match: {
        params: {classroomId},
      },
    } = this.props;
    fetchClassroom(classroomId).catch((err) => formatErrors(err, '/classrooms'));
  }

  render() {
    const {
      classroom,
      match: {
        params: {classroomId},
      },
    } = this.props;
    if (isEmpty(classroom)) {
      return null;
    }
    return (
      <div>
        <SecondaryNavigation hasBack />
        <div className="container content-box">
          <Panel>
            <SubscriptionOverview
              urlPrefix={`/classrooms/${classroomId}`}
              activatedSubscriptions={classroom.activatedSubscriptions}
              pendingSubscriptions={classroom.pendingSubscriptions}
              availableSubscriptions={classroom.availableSubscriptions}
              hideViewDetail
              ofClassroom
            />
          </Panel>
        </div>
        <SubscriptionList
          schoolId={classroom.schoolId}
          classroomId={classroomId}
          onSubscriptionCountUpdate={this.fetchClassroom}
        />
      </div>
    );
  }
}

export default connect(
  (state) => {
    const {classrooms} = state;
    return {
      classroom: classrooms.get('currentClassroom').toJS(),
    };
  },
  {
    addFlashMessage,
    formatErrors,
    fetchClassroom,
  },
)(ClassroomSubscriptionList);
